
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import Title from '../Title/index.vue'
import LazyImg from '@/components/lazyImg/index.vue'
import HeaderImage from '@xt/www/components/headerImage/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    Title,
    LazyImg,
    HeaderImage
  }
})
export default class MyStudy extends Vue {
  get PageStore() {
    return this.$store.$myV2.Classroom
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
